import {
  databaseRef,
  authRef,
  likePost,
  likePostComment,
  firestoreRef
} from 'api';

const forumRef = databaseRef.child('/forum');
const forumPostRef = forumRef.child('/posts');
const forumCommentRef = forumRef.child('/comments');

export async function createForumPost(forum) {
  let f = { ...forum };
  const newForum = forumPostRef.push();
  f.key = newForum.key;
  f.date = new Date().getTime();
  f.uid = authRef.currentUser.uid;
  f.imageURL = authRef.currentUser.photoURL;
  f.name = authRef.currentUser.displayName;
  await newForum.set(f);
  return f;
}

export async function updateForumPost(forum) {
  if (forum.key) {
    return forumPostRef.child(forum.key).update(forum);
  }
  throw Error({
    message: 'Something wrong!, Could not find the key of the forum'
  });
}

export async function deleteForumPost(postKey) {
  if (postKey) {
    return forumPostRef.child(postKey).remove();
  } else {
    throw Error({ message: 'Nothing specified to delete' });
  }
}

export async function shareForumPost(postKey) {}

export async function getForumPostDetails(key) {
  if (key) {
    return (await forumPostRef.child(key).once('value')).val();
  }
  return null;
}

export async function getSubjectsFromFirebase(onResult) {
  firestoreRef.collection('subjects').onSnapshot(data => {
    onResult(data.docs.map(d => d.data()));
  });
}

export async function likeForumPost(key) {
  return likePost({ postKey: key })
    .then(data => {
      return authRef.currentUser.uid;
    })
    .catch(e => {
      console.error(e);
    });
}
export async function likeForumPostComment(comment) {
  return likePostComment({ postKey: comment.postKey, commentKey: comment.key });
}

export async function getForumPosts(timestamp) {
  if (timestamp) {
    return (await forumPostRef
      .orderByChild('date')
      .limitToLast(5)
      .endAt(timestamp - 1)
      .once('value')).val();
  }
  return (await forumPostRef
    .orderByChild('date')
    .limitToLast(10)
    .once('value')).val();
}

export async function getForumPostComments(postKey) {
  return (await forumCommentRef.child(postKey).once('value')).val();
}

export async function addComment(comment) {
  let comm = comment;
  const newCommentRef = forumCommentRef.child(comm.postKey).push();
  comm.key = newCommentRef.key;
  comm.date = new Date().getTime();
  comm.uid = authRef.currentUser.uid;
  comm.imageURL = authRef.currentUser.photoURL;
  comm.name = authRef.currentUser.displayName;

  return newCommentRef.set(comm);
}

export async function updateForumPostComment(comment) {
  if (comment.key) {
    const newCommentRef = forumCommentRef
      .child(comment.postKey)
      .child(comment.key);
    return newCommentRef.set(comment);
  } else {
    throw Error('Cannot edit a comment that doesnot exist duh.');
  }
}

export async function deleteForumPostComment(comment) {
  if (comment.key) {
    const commentRef = forumCommentRef
      .child(comment.postKey)
      .child(comment.key);
    return commentRef.remove();
  } else {
    throw Error('Comment not found');
  }
}
